var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPlayStore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74.617,
    height: 74.617,
    viewBox: "0 0 74.617 74.617",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_15-google_play",
    "data-name": "15-google play",
    transform: "translate(-1 -0.958)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1577",
    "data-name": "Rectangle 1577",
    width: 74.617,
    height: 74.617,
    rx: 6,
    transform: "translate(1 0.958)",
    fill: "#e5e6e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14658",
    "data-name": "Path 14658",
    d: "M68.315,1H8.212A7.212,7.212,0,0,0,1,8.212V20.233A26.445,26.445,0,0,0,27.445,46.678H49.082A26.445,26.445,0,0,0,75.527,20.233V8.212A7.212,7.212,0,0,0,68.315,1Z",
    transform: "translate(0 0.048)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14660",
    "data-name": "Path 14660",
    d: "M68.315,60.212H8.212A7.212,7.212,0,0,1,1,53v4.808a7.212,7.212,0,0,0,7.212,7.212h60.1a7.212,7.212,0,0,0,7.212-7.212V53a7.212,7.212,0,0,1-7.212,7.212Z",
    transform: "translate(0 10.555)",
    fill: "#b8b8ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14661",
    "data-name": "Path 14661",
    d: "M52.165,29.841a4.2,4.2,0,0,1,0,7.236l-8.595,5.061-.156-.264L35,33.459l8.414-8.414.156-.264Z",
    transform: "translate(6.87 4.853)",
    fill: "#ffdf64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14662",
    "data-name": "Path 14662",
    d: "M14.016,57.243,39.259,32l8.414,8.414.156.264L18.512,57.928a3.877,3.877,0,0,1-1.923.517,3.772,3.772,0,0,1-2.669-1.106Z",
    transform: "translate(2.611 6.311)",
    fill: "#d74838"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14663",
    "data-name": "Path 14663",
    d: "M16.589,10a3.877,3.877,0,0,1,1.923.517L47.83,27.766l-.156.264-8.414,8.414L14.016,11.2l-.1-.1A3.772,3.772,0,0,1,16.589,10Z",
    transform: "translate(2.611 1.866)",
    fill: "#62d96e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14664",
    "data-name": "Path 14664",
    d: "M14.2,11.016,39.445,36.259,14.2,61.5l-.1.1A3.772,3.772,0,0,1,13,58.93V13.589a3.772,3.772,0,0,1,1.106-2.669Z",
    transform: "translate(2.425 2.052)",
    fill: "#01b5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14665",
    "data-name": "Path 14665",
    d: "M56.611,35.315l-8.595,5.061L18.7,57.625a3.876,3.876,0,0,1-1.923.517A3.776,3.776,0,0,1,13,54.368v3.606a3.776,3.776,0,0,0,3.774,3.774,3.877,3.877,0,0,0,1.923-.517l29.318-17.25,8.595-5.061A4.176,4.176,0,0,0,58.262,33.5,4.175,4.175,0,0,1,56.611,35.315Z",
    transform: "translate(2.425 6.614)",
    fill: "#b8b8ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14666",
    "data-name": "Path 14666",
    d: "M45.185,48.5l12.232-7.2a5.409,5.409,0,0,0,0-9.318l-37.91-22.3A4.981,4.981,0,0,0,12,13.981v4.635h2.4V13.981a2.557,2.557,0,0,1,.12-.752L37.948,36.647,14.524,60.066a2.557,2.557,0,0,1-.12-.752V25.829H12V59.313a4.983,4.983,0,0,0,7.507,4.295L43.142,49.7l-1.219-2.072L18.287,61.53a2.48,2.48,0,0,1-2.058.231L39.647,38.347l6.688,6.688L43.967,46.43ZM16.229,11.524a2.557,2.557,0,0,1,.752-.12,2.586,2.586,0,0,1,1.307.361L46.336,28.258l-6.688,6.689ZM41.347,36.647l7.129-7.129L56.2,34.06a3.005,3.005,0,0,1,0,5.169l-7.723,4.544Z",
    transform: "translate(2.223 1.664)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14667",
    "data-name": "Path 14667",
    d: "M12,19h2.4v2.4H12Z",
    transform: "translate(2.223 3.685)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlayStore);
export default __webpack_public_path__ + "static/media/icon-play-store.f448a2eb36db3e9959c3b018c3751ef0.svg";
export { ForwardRef as ReactComponent };